import Palette from '@opsbase/lib-palette';
import useCallforward from '@opsbase/react-hooks/useCallforward';
import useCss from '@opsbase/web-css';
import Horizontal from '@opsbase/web-layout/Horizontal';
import Pane from '@opsbase/web-layout/Pane';
import useNav from '@opsbase/web-nav/useNav';
import Button from '@opsbase/web-ui/Button';
import debounce from 'lodash/debounce';
import React, { useMemo, useState } from 'react';
const makeMyClasses = () => ({
    root: {
        position: 'absolute',
        right: 0,
        overflow: 'visible',
    },
    inner: {
        position: 'absolute',
        paddingLeft: 4,
        height: 52,
        top: 0,
        left: 0,
        zIndex: 2000,
    },
});
export const ItemMenu = React.memo((props) => {
    const { id, options = [], visible = false, children } = props;
    const { goTo } = useNav();
    const [overButtons, setOverButtons] = useState(false);
    const showButtons = visible || overButtons;
    const myCss = useCss(makeMyClasses);
    const doSetOverButtons = useMemo(() => debounce(v => setOverButtons(v), 400, { leading: false, trailing: true }), []);
    const handleClick = useCallforward(option => () => {
        if (option.onClick)
            return option.onClick();
        goTo(option.page, { id });
    }, [goTo, id]);
    const handleOverButtons = useCallforward(v => () => {
        doSetOverButtons(v);
        if (v === true)
            setOverButtons(true);
    }, [doSetOverButtons]);
    const childPane = useMemo(() => {
        if (!children)
            return [];
        return (React.createElement(Pane, { key: "childpane", grow: true }, children));
    }, [children]);
    return useMemo(() => {
        const visibleOptions = options.filter(option => option.visible === undefined || option.visible === true);
        return (React.createElement("div", { className: myCss.root }, !!(visibleOptions === null || visibleOptions === void 0 ? void 0 : visibleOptions.length) && (React.createElement(Horizontal, { classes: { root: myCss.inner }, onMouseEnter: handleOverButtons(true), onMouseLeave: handleOverButtons(false) }, [
            ...visibleOptions.map((option, idx) => (React.createElement(ItemMenuButton, { key: 'itemMenu' + idx, visible: showButtons, option: option, onClick: handleClick(option) }))),
            childPane,
        ]))));
    }, [options, myCss, handleOverButtons, childPane, showButtons, handleClick]);
});
export default ItemMenu;
const makeMyButtonClasses = visible => ({
    root: {
        margin: visible ? '2px 4px 2px 0' : 0,
        width: visible ? 52 : 0,
        maxWidth: visible ? undefined : 0,
        minWidth: visible ? undefined : 0,
        padding: visible ? undefined : 0,
        borderRadius: 0,
        transitionTimingFunction: 'ease-out',
        transition: 'width 0.33s, margin 0.33s, padding 0.33s, min-width 0.33s',
    },
    labelText: {
        whiteSpace: 'pre-wrap',
        width: 42,
        height: 24,
    },
});
function ItemMenuButton(props) {
    const { visible = false, option, onClick, onMouseEnter, onMouseLeave } = props;
    const color = option.variant === 'good'
        ? Palette.positive
        : option.variant === 'warn'
            ? Palette.error
            : option.variant === 'action'
                ? Palette.secondary
                : Palette.GreyBlue;
    const label = option.label;
    const tip = option.tip;
    const myCss = useCss(makeMyButtonClasses, [visible]);
    const icon = useMemo(() => (option.icon ? React.createElement(option.icon, { size: 14, color: Palette.White }) : undefined), [option]);
    return useMemo(() => (React.createElement(Button, { classes: myCss, small: true, tiny: label, round: !label, nowrap: true, maxLabelWidth: 52, color: color, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onClick: onClick, iconAbove: label ? icon : undefined, icon: label ? undefined : icon, label: label, tooltip: tip })), [color, icon, label, myCss, onClick, onMouseEnter, onMouseLeave, tip]);
}
